import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

const isRiderRole = (role = localStorage.getItem('userRole')) => role === 'rider';

export const syncRiderServiceWorker = (role = localStorage.getItem('userRole')) => {
  if (isRiderRole(role)) {
    serviceWorkerRegistration.register();
  } else {
    serviceWorkerRegistration.unregister();
  }
};
